var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRiskGroupsFullyEnforcedCs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jhbmih3gja",
    d: "M0 0h16.667v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.025 7.179.642 1.453c.042.084.125.147.208.147l1.554.168c.373.043.518.527.249.78l-1.16 1.073c-.063.063-.105.168-.084.253l.311 1.558a.439.439 0 0 1-.642.484l-1.369-.78a.303.303 0 0 0-.269 0l-1.347.78a.439.439 0 0 1-.643-.484l.311-1.558c.02-.085-.02-.19-.083-.253l-1.16-1.074c-.27-.252-.125-.737.248-.779l1.555-.168c.103-.021.186-.063.207-.147l.643-1.453c.186-.358.684-.358.829 0zM4.682 6.61v2.885c0 4.168 4.85 7.22 5.949 7.852 1.098-.652 5.949-3.705 5.949-7.852V6.61c-2.591-.336-4.664-1.957-5.95-3.263C9.347 4.653 7.274 6.274 4.683 6.61z",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.277)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q4bbkzeahb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jhbmih3gja"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.422 9.495c0 5.347-6.509 8.842-6.778 8.99l-.29.147-.29-.148c-.27-.147-6.779-3.642-6.779-8.99V5.559l.601-.042c3.11-.21 5.493-2.61 6.488-3.832.995 1.221 3.358 3.621 6.468 3.832l.6.042v3.937h-.02zm.684-5.18-1.182-.083C11.442 4 8.914.316 8.892.274A.645.645 0 0 0 8.374 0a.645.645 0 0 0-.518.274C7.815.316 5.265 4 1.783 4.232L.6 4.316A.644.644 0 0 0 0 4.968v4.527C0 15.6 7.151 19.453 7.462 19.62l.58.316a.653.653 0 0 0 .29.063.653.653 0 0 0 .291-.063l.58-.316c.311-.168 7.463-4.02 7.463-10.126V4.969a.61.61 0 0 0-.56-.653z",
    fill: "#AEB3B7",
    mask: "url(#q4bbkzeahb)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskGroupsFullyEnforcedCs);
export default __webpack_public_path__ + "static/media/high-risk-groups-fully-enforced-cs.fd264d4500885b47a85b5fbaf8ae1e83.svg";
export { ForwardRef as ReactComponent };